import { Grid } from '@mui/material';
import React, { FC } from 'react';
import { FieldArrayWithId } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import EmptyState from './empty-state';
import ListItemElement from './list-items-element';
import SectionItemTitle from './container-items';

type RelationsSectionProps = {
  contactId: string;
  parents: FieldArrayWithId<any, any, any>[];
  subordinates: FieldArrayWithId<any, any, any>[];
  onOpenModal: () => void;
  deletePartyAssociation: (...args: any[]) => void;
  dispatchDelete: (action: any) => void;
};

const RelationsSection: FC<RelationsSectionProps> = ({
  contactId,
  parents,
  subordinates,
  onOpenModal,
  deletePartyAssociation,
  dispatchDelete,
}) => {
  const { t } = useTranslation();

  return (
    <Grid item>
      <SectionItemTitle
        title={t('contact:relationsTitle')}
        onClickIcon={onOpenModal}
      >
        {parents.length > 0 || subordinates.length > 0 ? (
          <>
            {/* eslint-disable react/no-array-index-key -- composite key uses index suffix because backend returns duplicate _id values across parties */}
            {parents.length > 0 &&
              parents.map((f, idx) => (
                <ListItemElement
                  key={`${f._id}-parent-${idx}`}
                  title={f.kind}
                  value={t('contact:relation-on', { name: f.name })}
                  relation
                  relationType="parent"
                  disabledButton={false}
                  onclickIcon={() => {
                    dispatchDelete({
                      type: 'delete',
                      data: {
                        func: deletePartyAssociation,
                        params: {
                          id: contactId,
                          kind: f.kind,
                          partyId: f._id,
                        },
                      },
                      message: t('contact:deleteAssociationParentMessage', {
                        kind: f.kind,
                        name: f.name,
                      }),
                      title: t('contact:deleteAssociationTitle'),
                    });
                  }}
                />
              ))}
            {subordinates.length > 0 &&
              subordinates.map((f, idx) => (
                <ListItemElement
                  key={`${f._id}-subordinate-${idx}`}
                  title={f.name}
                  value={t('contact:relation-as', { kind: f.kind })}
                  relation
                  relationType="subordinate"
                  disabledButton={false}
                  onclickIcon={() => {
                    dispatchDelete({
                      type: 'delete',
                      data: {
                        func: deletePartyAssociation,
                        params: {
                          id: f._id,
                          kind: f.kind,
                          partyId: contactId,
                        },
                      },
                      message: t('contact:deleteAssociationSubordinateMessage', {
                        name: f.name,
                        kind: f.kind,
                      }),
                      title: t('contact:deleteAssociationTitle'),
                    });
                  }}
                />
              ))}
            {/* eslint-enable react/no-array-index-key */}
          </>
        ) : (
          <EmptyState />
        )}
      </SectionItemTitle>
    </Grid>
  );
};

export default RelationsSection;
